import { api } from '@/api/api';

export interface UpdateSurveyLanguageVariables {
    /**
     * The answer the reviewer arrived at from their email link. The person whose language changes is
     * read from it on the server, never named by the client (bug 16636).
     */
    reviewAnswerId: string;
    lang: string;
}

const engagementUserService = {
    async updateSurveyLanguage({
        reviewAnswerId,
        lang,
    }: UpdateSurveyLanguageVariables): Promise<void> {
        await api.post(`/reviewanswer/${reviewAnswerId}/survey-language`, { lang });
    },
};

export default engagementUserService;
